import React from 'react'
import { Grid, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { reduxForm, Field } from 'redux-form';
import RenderTextFieldRedux from '../Complements/RenderTextFieldReduxLower';
import RenderTextFieldReduxEmail from '../Complements/RenderTextFieldReduxEmail';
const useStyles = makeStyles(theme => ({
    textField: {
        width: 200,
    },
    margin: {
        margin: theme.spacing(1),
    },
}));
const validate = values => {
    const error  = {}
    if (!values.alias) {
        error.alias = "El alias es obligatorio"
    }
    if (!values.email) {
        error.email = "El email es obligatorio"
    }
    if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        error.email = 'Correo electrónico no válido'
    }
    return error
}
const FormGenerateQr = props => {
    const {
        handleSubmit,
        pristine
    } = props
    const classes = useStyles();
    return (
        <div>
            <form className={classes.form} onSubmit={ handleSubmit }>
                <Grid container justifyContent='center' style={{ gap: 16 }}>

                    <Grid item xs={12} md={12} lg={6} xl={6} style={{ padding: "20px 0" }}>
                        <Field
                            name="alias"
                            id="alias"
                            autoFocus = { true }
                            component={ RenderTextFieldRedux }
                            label="Alias"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={6} xl={6} style={{ padding: "20px 0" }}>
                        <Field
                            name="email"
                            id="email"
                            autoFocus = { true }
                            component={ RenderTextFieldReduxEmail }
                            label="Email"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={6} xl={6}>
                        <Button variant="contained" type="submit"
                            style = {{
                                        fontSize: 14,
                                        color: '#ffffff',
                                        borderRadius: 10,
                                        height: 40
                                    }}
                            color="primary"
                            disabled={pristine }
                            >
                            Generar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </div>
    )
}
const FormGenerateQrReduxForm = reduxForm(
    {
        form: 'FormGenerateQr',
        validate
    }
)(FormGenerateQr)
export default FormGenerateQrReduxForm
